import { PayoutPoolStatus } from '../infra/dtos';

const STATUS_COLORS = {
  info: { backgroundColor: 'rgba(59, 130, 246, 0.08)', color: '#3b82f6' },
  success: { backgroundColor: 'rgba(16, 185, 129, 0.08)', color: '#10b981' },
  warning: { backgroundColor: 'rgba(245, 158, 11, 0.08)', color: '#f59e0b' },
  error: { backgroundColor: 'rgba(239, 68, 68, 0.08)', color: '#ef4444' },
};

export function usePayoutPoolStatusColors(): Record<PayoutPoolStatus, { backgroundColor: string; color: string }> {
  return {
    [PayoutPoolStatus.Calculating]: STATUS_COLORS.info,
    [PayoutPoolStatus.Calculated]: STATUS_COLORS.success,
    [PayoutPoolStatus.PayoutsCreated]: STATUS_COLORS.success,
    [PayoutPoolStatus.Stopped]: STATUS_COLORS.warning,
    [PayoutPoolStatus.Failed]: STATUS_COLORS.error,
  };
}
